import {ErrorImage} from '@pinecast/common/ErrorState';
import {VerticalGroup} from '@pinecast/common/Group';
import {DesktopPageHeader, P} from '@pinecast/common/Text';
import {defineMessage, FormattedMessage} from '@pinecast/i18n';

import {usePageTitle} from './usePageTitle';

const title = defineMessage({
  description:
    'Title and heading of the dashboard page that shows when there is no page at the address, such as an old or a mistyped link',
  defaultMessage: 'Page not found',
});

/**
 * What a dashboard shows at an address that is none of its pages. It names
 * itself inside the name of the dashboard ("Page not found - My Podcast -
 * Pinecast"), where the address used to show the generic "Dashboard" and an
 * empty page. The heading is the page's own (`DesktopPageHeader`), not the
 * one of `ErrorState`, so it has the level of a page heading and holds the
 * menu button on a phone.
 */
const PageNotFound = () => {
  usePageTitle(title);
  return (
    <>
      <DesktopPageHeader>
        <FormattedMessage {...title} />
      </DesktopPageHeader>
      <VerticalGroup
        centerChildren
        spacing={16}
        wrapperStyle={{padding: '12px 0', textAlign: 'center'}}
      >
        <ErrorImage />
        <P>
          <FormattedMessage
            description="Text of the dashboard page that shows when there is no page at the address"
            defaultMessage="There is no page at this address. Choose a page from the menu."
          />
        </P>
      </VerticalGroup>
    </>
  );
};

export default PageNotFound;
